import { render, staticRenderFns } from "./ManifestacaoMinha.vue?vue&type=template&id=215ef408&"
import script from "./ManifestacaoMinha.vue?vue&type=script&lang=js&"
export * from "./ManifestacaoMinha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports